<template>
    <div class="col-lg-6 mb-4">
        <div class="box">
            <div class="box-offset">
                <div class="box-ttl-wrap">
                    <div class="box-ttl">Recent Applicants</div>
                </div>
                <div class="table-holder table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th >Stage</th>
                            <th class="text-right">Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="applicant in listOfApplicants"
                            :key="applicant.id"
                        >
                            <td class="avatar-col">
                                <div class="user-info">
                                    <div
                                        class="avatar"
                                        :style="{'background-image': applicant.avatar ?  `url('/uploads/${applicant.avatar}')` : 'url(/img/svg/emptyAvatar.png)'}"
                                    ></div>
                                </div>
                            </td>
                            <td>
                                <div class="user-info">
                                    <a
                                        class="name"
                                        :href="`/master-admin/applicants/${applicant.id}/show?tab=Stages/Progress`"
                                    >{{applicant.name}} {{applicant.last_name}}</a>
                                </div>
                            </td>
                            <td>
                                {{applicant.stages}}
                            </td>
                            <td class="text-right">
                                <div class="small-text">
                                    {{applicant.date_applied | momentFromNow }}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-center">
                    <a href="/master-admin/applicants" class="link">View All</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import DashboardService from "./DashboardService";

export  default {
    name: 'ApplicantsBoard',
    computed: {
        app() {
            return app
        }
    },
    data() {
        return {
            listOfApplicants: [],
        }
    },
    methods: {
        async getListOfApplicants() {
            try {
                const {data: response} = await DashboardService.getApplicantsInfo()
                this.listOfApplicants = response
            } catch (e) {
                console.error(e)

            }
        }
    },
    mounted() {
        this.getListOfApplicants()
    }
}

</script>



<style scoped>

</style>
